import { useCallback, useState } from 'react';
import axios, { AxiosError } from 'axios';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Drawer from '@mui/material/Drawer';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoaderAnim from '@/components/animations/loader';
import { useProfile } from '.';
import Box from '@mui/material/Box';

type ProfileAuthModalProps = {
  isOpen: boolean
  //isMobile: boolean
  handleClose: any
}

export default function ProfileAuthModal (props: ProfileAuthModalProps) {
  const profile = useProfile()!;
  const [ email, setEmail ] = useState<string>('');
  const [ processing, setProcessing ] = useState<boolean>(false);
  const [ error, setError ] = useState<string>('');

  const close = useCallback((isSystem?: true) => {
    if (email) setEmail('');
    if (error) setError('');
    props.handleClose();
    if (!isSystem) profile.needOpenProfileAfterAuth(false);
  }, [profile, email]);

  const back = useCallback((_event: any) => {
    setEmail('');
    setError('');
  }, []);

  const request = useCallback((email: string) => {
    email = email.toLowerCase();
    setError('');
    axios.post('/api/profile/auth/request', { email }).then(({ data }) => {
      if (data === email) {
        setEmail(email);
      } else {
        setError('Запрос происходил на другую эл. почту... Попробуйте еще раз.');
      }
      setProcessing(false);
    }).catch((e: AxiosError) => {
      const err = e.response?.data;
      console.error(err);
      setError(typeof err === 'string' ? err : 'Произошла ошибка, подробности в консоли (нажать F12)');
      setProcessing(false);
    });
  }, []);

  const confirm = useCallback((email: string, dirtyCode: string) => {
    email = email.toLowerCase();
    setError('');
    const code = dirtyCode.replace(/[\-\.\_\s]+/g, '');
    axios.post('/api/profile/auth/confirm', { email, code }).then(({ data }) => {
      setProcessing(false);
      setEmail('');
      window.gtag('event', 'finished_auth');
      profile.init(data);
      close(true);
    }).catch((e: AxiosError) => {
      const err = e.response?.data;
      console.error(err);
      setError(typeof err === 'string' ? err : 'Произошла ошибка, подробности в консоли (нажать F12)');
      setProcessing(false);
    });
  }, []);

  return <Dialog
  open={props.isOpen}
  onClose={() => close()}
  PaperProps={{
    component: 'form',
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (processing) return false;
      const formData = new FormData(event.currentTarget);
      const formJson = Object.fromEntries((formData as any).entries());
      if (!email) {
        if (formJson.email) {
          setProcessing(true);
          request(formJson.email);
        }
      } else {
        if (formJson.code) {
          setProcessing(true);
          confirm(email, formJson.code);
        }
      }
    },
  }}
  >
    <DialogTitle>Авторизация</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {
          !email ?
            <Stack
              direction="row"
              justifyContent="start"
              alignItems="start"
              spacing={3}
            >
              <div><img src='/email.png' width={50} /></div>
              <div><b>Быстрая авторизация</b> - просто укажите свою электронную почту и подтвердите её полученным в письме кодом!</div>
            </Stack>
          :
            <Stack
              direction="row"
              justifyContent="start"
              alignItems="start"
              spacing={3}
            >
              <div><img src='/password.png' width={50} /></div>
              <div><b>Проверьте свою почту</b>, если там нет письма от адреса <u>security@rumanga.download</u>, то проверьте папку со спамом.</div>
            </Stack>
        }
      </DialogContentText>
      <TextField
        autoFocus
        required
        margin="dense"
        id="name"
        name="email"
        label="Адрес электронной почты (e-mail)"
        type="email"
        fullWidth
        variant="standard"
        disabled={!!email}
      />
      {
        email ?
          <>
            <TextField
              autoFocus
              required
              margin="dense"
              id="code"
              name="code"
              label="Код авторизации"
              fullWidth
              variant="standard"
              autoComplete='false'
              autoCorrect='false'
              autoSave='false'
              autoCapitalize='false'
            />
          </>
        : ''
      }
    </DialogContent>
    { error ? <div style={{ background: '#ff4c43', color: 'white', fontSize: '18px', padding: '5px 25px' }}>{error}</div> : '' }
    <DialogActions>
      <Button onClick={(event) => email ? back(event) : close()}>{!email ? 'Отмена' : 'Назад'}</Button>
      <Button type="submit">{!email ? 'Далее' : 'Подтвердить'}</Button>
    </DialogActions>
    { processing ? <LoaderAnim /> : '' }
  </Dialog>;
}

export function ProfileAuthMobile (props: ProfileAuthModalProps) {
  const profile = useProfile()!;
  const [ email, setEmail ] = useState<string>('');
  const [ processing, setProcessing ] = useState<boolean>(false);
  const [ error, setError ] = useState<string>('');

  const close = useCallback((isSystem?: true) => {
    if (email) setEmail('');
    if (error) setError('');
    props.handleClose();
    if (!isSystem) profile.needOpenProfileAfterAuth(false);
  }, [email]);

  const back = useCallback((_event: any) => {
    setEmail('');
    setError('');
  }, []);

  const request = useCallback((email: string) => {
    email = email.toLowerCase();
    setError('');
    axios.post('/api/profile/auth/request', { email }).then(({ data }) => {
      if (data === email) {
        setEmail(email);
      } else {
        setError('Запрос происходил на другую эл. почту... Попробуйте еще раз.');
      }
      setProcessing(false);
    }).catch((e: AxiosError) => {
      const err = e.response?.data;
      console.error(err);
      setError(typeof err === 'string' ? err : 'Произошла ошибка, подробности в консоли (нажать F12)');
      setProcessing(false);
    });
  }, []);

  const confirm = useCallback((email: string, dirtyCode: string) => {
    email = email.toLowerCase();
    setError('');
    const code = dirtyCode.replace(/[\-\.\_\s]+/g, '');
    axios.post('/api/profile/auth/confirm', { email, code }).then(({ data }) => {
      setProcessing(false);
      setEmail('');
      window.gtag('event', 'finished_auth');
      profile.init(data);
      close(true);
    }).catch((e: AxiosError) => {
      const err = e.response?.data;
      console.error(err);
      setError(typeof err === 'string' ? err : 'Произошла ошибка, подробности в консоли (нажать F12)');
      setProcessing(false);
    });
  }, []);

  return <Drawer
    anchor='bottom'
    open={props.isOpen}
    onClose={() => close()}
    PaperProps={{
      sx: {
        paddingBottom: ((window as any).mobilemenu?.clientHeight ?? 0) + 40 + 'px',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        borderTop: '5px solid #ed6c02',
        paddingTop: '10px',
      },
      component: 'form',
      onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (processing) return false;
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries((formData as any).entries());
        if (!email) {
          if (formJson.email) {
            setProcessing(true);
            request(formJson.email);
          }
        } else {
          if (formJson.code) {
            setProcessing(true);
            confirm(email, formJson.code);
          }
        }
      },
    }}
  >
    <Box padding={'20px 40px'} sx={{ zoom: `max(${650 / window.screen.availWidth}, 1)` }}>
      {
        !email ?
          <Stack
            direction="row"
            justifyContent="start"
            alignItems="start"
            spacing={3}
          >
            <div><img src='/email.png' width={50} /></div>
            <div><b>Быстрая авторизация</b> - просто укажите свою электронную почту и подтвердите её полученным в письме кодом!</div>
          </Stack>
        :
          <Stack
            direction="row"
            justifyContent="start"
            alignItems="start"
            spacing={3}
          >
            <div><img src='/password.png' width={50} /></div>
            <div><b>Проверьте свою почту</b>, если там нет письма от адреса <u>security@rumanga.download</u>, то проверьте папку со спамом.</div>
          </Stack>
      }
      <TextField
        autoFocus
        required
        margin="dense"
        id="name"
        name="email"
        label="Адрес электронной почты (e-mail)"
        type="email"
        fullWidth
        variant="standard"
        disabled={!!email}
      />
      {
        email ?
          <>
            <TextField
              autoFocus
              required
              margin="dense"
              id="code"
              name="code"
              label="Код авторизации"
              fullWidth
              variant="standard"
              autoComplete='false'
              autoCorrect='false'
              autoSave='false'
              autoCapitalize='false'
            />
          </>
        : ''
      }
      { error ? <div style={{ background: '#ff4c43', color: 'white', fontSize: '18px', padding: '5px 25px' }}>{error}</div> : '' }
      <Box display='flex' justifyContent='space-between' marginTop='15px'>
        <Button color='inherit' variant='outlined' onClick={(event) => email ? back(event) : close()}>{!email ? 'Отмена' : 'Назад'}</Button>
        <Button color='info' variant='contained' type="submit">{!email ? 'Далее' : 'Подтвердить'}</Button>
      </Box>
    </Box>
    { processing ? <LoaderAnim /> : '' }
  </Drawer>
}